import React from 'react';

const ContentHistoryHeading = (props) => {
  const { Heading } = props;

  if (!props.Heading) return null;

  if (props.CurrentPageProps.PageTypeName === 'StartPage') {
    if (props.Link) {
      return (
        <a href={props.Link}>
          <h3 className="content-history__heading">
            <i className="content-history__heading__icon"></i>
            {Heading}
          </h3>
        </a>
      );
    }

    return <h3 className="content-history__heading">{Heading}</h3>;
  }

  return null;
};

export default ContentHistoryHeading;
